import { useCallback } from "react";
import { useDispatch } from "src/redux/hooks";
import {
  setGuernseyData,
  setGuernseyType,
} from "src/redux/slices/generatorFeaturesSlice";

const useResetGuernsey = () => {
  const dispatch = useDispatch();
  return useCallback(() => {
    dispatch(setGuernseyData(null));
    dispatch(setGuernseyType(null));
  }, [dispatch]);
};
export default useResetGuernsey;
